import { render } from "./payOrder.vue?vue&type=template&id=6e422044"
import script from "./payOrder.vue?vue&type=script&lang=js"
export * from "./payOrder.vue?vue&type=script&lang=js"

import "./payOrder.vue?vue&type=style&index=0&id=6e422044&lang=less"
script.render = render

export default script